import StorageKeys from "../../../const/StorageKeys";
import CacheStorage from "../../../service/storage/CacheStorage";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { BranchGroupListModel } from "../../../model/branch/BranchGroupsModel";
import ShowToast from "../../../widget/common/ui/Toast";

const BranchGroupsProvider = new (class BranchGroupsProvider {
  getGroupListAPI = async (): Promise<BranchGroupListModel | null> => {
    ApiUrls.init();

    const barnchId: string = CacheStorage.getValue(StorageKeys.branch_id);
    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}search/get_group_list`;
    const body: any = {
      account_id: accountId,
      branch_id: barnchId,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const branchGroupListModel: BranchGroupListModel = response;
        return branchGroupListModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default BranchGroupsProvider;
